import { checkOverrideConfigInSession } from '@libs/configOverride'
import { useEffect } from 'react'

export const useConfigOverrideExpiration = () => {
  useEffect(() => checkOverrideConfigInSession(), [])
}
